import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import { MixinConfigurationModule} from "./../Shared/configuration";
import { MixinDetect } from "./../startdetection/index";
import * as Vue from 'vue';
import { VueSignalR } from './../../Scripts/js/signalrmonitoring.service';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { createPinia } from 'pinia';

export class LandingPageComponent {
    public Init(initdesc: string,lancurrent:string,landingpageid:number) {
        (<any>(window)).g_initdesc = initdesc;
        (<any>(window)).g_landingpageid = landingpageid;
        (<any>(window)).g_lancurrent = lancurrent;
        DCApp.mixins = [MixinDetect, MixinConfigurationModule];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        const connection = new HubConnectionBuilder().withUrl('/SignalRDriversCloud').build();
        app.use(VueSignalR, connection);
        app.mount('#rootpage');
    }
}
(<any>(window)).LandingPageComponent = function () { return new LandingPageComponent(); };